/* eslint-disable prettier/prettier */
import React, { FC } from 'react';
import { Link } from 'gatsby';
import useScreenRecognition from 'gatsby-theme-husky/src/hooks/useScreenRecognition';

import { INavItem } from './models';

import './NavItem.scss';

const NavItem: FC<INavItem> = ({
  navItem,
  hasSubMenu,
  activeNavItem,
  setExpanded,
  setActiveNavItem,
}) => {
  const { isMobile } = useScreenRecognition();

  return (
    <>
      <Link
        to={navItem?.url[0]?.url}
        className={`text-uppercase nav-link d-flex ${hasSubMenu ? 'has-dropdown' : ''}`}
        title={navItem?.label || ''}
        data-testid="header-nav-link"
        onClick={(e) => {
          if (isMobile && hasSubMenu) {
            if (activeNavItem !== navItem.label) {
              e.preventDefault();
              setActiveNavItem(navItem.label);
            } else {
              setExpanded(false);
              if (navItem?.url[0]?.url) {
                window.location.href = navItem.url[0].url;
              }
            }
          } else {
            setExpanded(false);
          }
        }}
      >
        {navItem?.label}
      </Link>

      {hasSubMenu && activeNavItem === navItem.label && (
        <div className="dropdown-menu">
          {navItem.navigationWithSubMenu.map((submenu) => (
            <div key={`${submenu.label}-${submenu.url[0].url}`} className="dropdown-item">
              <Link
                to={submenu.url[0].url}
                className="nav-link"
                title={submenu.label}
                onClick={() => setExpanded(false)}
              >
                {submenu.label}
              </Link>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default NavItem;
